import {
	Component,
	OnInit,
	OnChanges,
	Input,
	Output,
	EventEmitter,
	ElementRef,
} from "@angular/core";

@Component({
	selector: "app-mcq",
	templateUrl: "./mcq.directive.html",
	styleUrls: ["./mcq.directive.css"],
})
export class McqDirective implements OnChanges {
	@Input() quizOptions: Array<any>;
	@Input() quizType: string; //multiple or single
	@Output() choiceSelected?: EventEmitter<any> = new EventEmitter<any>();
	@Input() optionFontsize?: string;
	@Input() optionFontColor?: String;
	@Input() textDirection: string;

	private selectedOption: any = null;
	constructor(private elRef: ElementRef) {}

	ngOnInit() {}
	ngOnChanges(changes) {}
	public optionSelecthandler(event) {
		let option = event.item;
		if (this.quizType == "multiple") {
			// console.log('multiplechoice ',option);
		} else {
			if (this.selectedOption != null) {
				// console.log("this.selectedOption ",this.selectedOption);
				this.selectedOption.selected = false;
				this.selectedOption.backgroundColor = "";
			}
			this.selectedOption = this.selectedOption != option ? option : null;
		}
		if (this.isOptionSelected()) {
			this.choiceSelected.emit({ status: "selected" });
		} else {
			this.choiceSelected.emit({ status: "notselected" });
		}
	}
	private isOptionSelected(): Boolean {
		let bSelected: Boolean = false;
		for (let item of this.quizOptions) {
			if (item.selected == true) {
				bSelected = true;
				break;
			}
		}
		return bSelected;
	}
}
